import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface FinalizeReviewParams {
  messageForPatient: string;
}

/**
 * Finalizes a lab result review for async-labs Universal Clinic patients.
 * Unlike triage submission, this only sends a patient message — there is no
 * triage level for these patients.
 */
export const useFinalizeReview = ({
  patientId,
  serviceRequestId,
}: {
  patientId: string;
  serviceRequestId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<unknown, FinalizeReviewParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.Labs.FINALIZE_REVIEW(
        patientId,
        serviceRequestId,
      ),
      mutationFn: (params: FinalizeReviewParams) => {
        return axiosInstance.post("/labs/results/finalize-review", {
          service_request_id: serviceRequestId,
          message_for_patient: params.messageForPatient,
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Labs.DEFAULT(patientId),
        });
      },
    },
  });
};
